import { BasicContent } from './BasicContent';
import PadpPromoCalc from '../../ComponentLibrary/calculators/PadpPromoCalc';

const CMSPadpPromoCalc = ({ content }) => (
  <>
    <BasicContent {...content.copy} />
    <PadpPromoCalc />
  </>
);

export default CMSPadpPromoCalc;
